import { createEvent } from 'effector';

export const changeActiveFilterEv = createEvent();

export const resetGradientEv = createEvent();
